import React, { useEffect, useState } from 'react';
import './FilterSelect.css';
import { formatDateForInput } from '../functions/formatDateForInput';
import { formatDateForAPI } from '../functions/formatDateForAPI';

interface FilterDateProps {
  name: string;
  label: string;
  valueFrom?: string;
  valueTo?: string;
  onChange?: (name: string, value: any) => void;
}

export const FilterDate: React.FC<FilterDateProps> = ({
  name,
  label,
  valueFrom,
  valueTo,
  onChange,
}) => {
  const [fromValue, setFromValue] = useState<string>('');
  const [toValue, setToValue] = useState<string>('');

  const emitRange = (nextFrom: string, nextTo: string) => {
    const apiFrom = formatDateForAPI(nextFrom);
    const apiTo = formatDateForAPI(nextTo);

    // Require both values to apply filters
    if (apiFrom && apiTo) {
      onChange && onChange(`${name}.gte`, `${name}.gte(${apiFrom})`);
      onChange && onChange(`${name}.lte`, `${name}.lte(${apiTo})`);
    } else {
      onChange && onChange(`${name}.gte`, '');
      onChange && onChange(`${name}.lte`, '');
    }
  };

  const handleFromChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setFromValue(newValue);
    emitRange(newValue, toValue);
  };

  const handleToChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setToValue(newValue);
    emitRange(fromValue, newValue);
  };

  const handleClear = () => {
    setFromValue('');
    setToValue('');
    emitRange('', '');
  };

  useEffect(() => {
    if (valueFrom !== undefined) {
      const formattedFrom = formatDateForInput(valueFrom);
      setFromValue(formattedFrom);
    }
  }, [valueFrom]);

  useEffect(() => {
    if (valueTo !== undefined) {
      const formattedTo = formatDateForInput(valueTo);
      setToValue(formattedTo);
    }
  }, [valueTo]);

  return (
    <div>
      <div className="filter-date-range">
        <div className="filter-date-range-field">
          <span className="filter-date-range-label">{label} from</span>
          <input
            type="date"
            className="filter-text-input filter-text-input-date"
            name={`${name}-from`}
            value={fromValue}
            onChange={handleFromChange}
            aria-label="Date from"
          />
        </div>
        <div className="filter-date-range-field">
          <span className="filter-date-range-label">{label} to</span>
          <input
            type="date"
            className="filter-text-input filter-text-input-date"
            name={`${name}-to`}
            value={toValue}
            onChange={handleToChange}
            aria-label="Date to"
          />
        </div>
        {(fromValue || toValue) && (
          <button
            type="button"
            className="filter-text-clear"
            onClick={handleClear}
            aria-label="Clear"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};
